// 마켓 API 응답의 파일 3칸(First/Second/Third)에서 2D 이미지와 3D 에셋 파일을 찾아낸다.
// 파일이 없어도 fileUrl 값은 도메인만 채워져 내려오므로 fileName 유무로 판단한다.
const MODEL_EXT = /\.glb$/i;
const IMAGE_EXT = /\.(jpg|jpeg|png|gif)$/i;

export const is3dFileName = name => MODEL_EXT.test(name || '');
export const isImageFileName = name => IMAGE_EXT.test(name || '');

export const getMarketFiles = item => {
  const result = { imageUrl: '', imageName: '', modelUrl: '', modelName: '' };
  if (!item) return result;

  ['First', 'Second', 'Third'].forEach(slot => {
    const name = item[`fileName${slot}`];
    const url = item[`fileUrl${slot}`];
    if (!name || !url) return;
    if (!result.modelUrl && is3dFileName(name)) {
      result.modelUrl = url;
      result.modelName = name;
    } else if (!result.imageUrl && isImageFileName(name)) {
      result.imageUrl = url;
      result.imageName = name;
    }
  });

  return result;
};
